import { Box, Paper, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

interface ResponsiveRecordField {
  label: string;
  value: React.ReactNode;
}

interface ResponsiveRecordCardProps {
  eyebrow?: string;
  title: React.ReactNode;
  badge?: React.ReactNode;
  fields: ResponsiveRecordField[];
  actions?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const ResponsiveRecordCard: React.FC<ResponsiveRecordCardProps> = ({
  eyebrow,
  title,
  badge,
  fields,
  actions,
  sx,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 1.75, sm: 2.5 },
        borderRadius: 3,
        border: '1px solid #e5e7eb',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1.5, mb: 2, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <Box>
          {eyebrow && (
            <Typography variant="overline" sx={{ color: '#5b6b83', letterSpacing: 1.1, fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
              {eyebrow}
            </Typography>
          )}
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f265c', fontSize: { xs: '1rem', sm: '1.25rem' } }}>
            {title}
          </Typography>
        </Box>
        {badge}
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
          gap: 1.5,
          mb: actions ? 2 : 0,
        }}
      >
        {fields.map((field) => (
          <Box key={field.label} sx={{ p: { xs: 1.25, sm: 1.5 }, borderRadius: 2, bgcolor: '#fff' }}>
            <Typography variant="caption" color="text.secondary">
              {field.label}
            </Typography>
            <Box sx={{ mt: 0.5 }}>{field.value}</Box>
          </Box>
        ))}
      </Box>

      {actions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, flexWrap: 'wrap' }}>
          {actions}
        </Box>
      )}
    </Paper>
  );
};

export default ResponsiveRecordCard;
